import { defineMessages } from 'react-intl';

const messages = defineMessages({
  virtualUrl: {
    id: 'hubs.repvisits.virtualUrl',
    defaultMessage: 'Virtual Visit Link',
  },
  virtualWarning: {
    id: 'hubs.repvisits.virtualWarning',
    defaultMessage: 'Virtual Visit (Link available at visit time)',
  },
});

export default messages;
